export const DATE_TIME_FORMAT = "MM-DD-YYYY h:mm A";
export const DATE_FORMAT = "MM-DD-YYYY";
export const STANDARD_DATE_FORMAT_NO_TIME = "YYYY-MM-DD";
export const ALLERGY_CODETYPE = `${process.env.REACT_APP_FHIR_ENDPOINT}/fhir/StructureDefinition/allergy-codetype`;
export const ALLERGEN_TYPE = `${process.env.REACT_APP_FHIR_ENDPOINT}/fhir/StructureDefinition/allergen-type`;
export const DISPENSIBLE_DRUG_ID_SYSTEM = `${process.env.REACT_APP_FHIR_ENDPOINT}/fhir/StructureDefinition/dispensible-drug-id`;
export const ROUTED_DRUG_ID_SYSTEM = `${process.env.REACT_APP_FHIR_ENDPOINT}/fhir/StructureDefinition/routed-drug-id`;
export const DRUG_STRENGTH_SYSTEM = `${process.env.REACT_APP_FHIR_ENDPOINT}/fhir/StructureDefinition/drug-strength`;
export const DRUG_FREQUENCY_SYSTEM = `${process.env.REACT_APP_FHIR_ENDPOINT}/fhir/StructureDefinition/drug-frequency`;
export const DRUG_NDC_SYSTEM = `${process.env.REACT_APP_FHIR_ENDPOINT}/fhir/StructureDefinition/drug-ndc`;
export const DRUG_RX_CUI_SYSTEM = `${process.env.REACT_APP_FHIR_ENDPOINT}/fhir/StructureDefinition/drug-rx-cui`;
export const locationTagSystem = "http://hl7.org/fhir/tags/location";

export const mongoConfig = {
  maxPoolSize: 5,
  minPoolSize: 1,

  serverSelectionTimeoutMS: 5000,
  socketTimeoutMS: 45000,
  heartbeatFrequencyMS: 5000,

  retryWrites: true,
  retryReads: true,

  keepAlive: true,
  keepAliveInitialDelay: 300000,
};
